module.exports = __webpack_public_path__ + "img/default-submissions.b4bb6536.png";